module.exports = __webpack_public_path__ + "img/bj_03.dc8f9acc.jpg";